import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import './ResultPage2.scss';

const ResultPage2 = () => {
	const navigate = useNavigate(); // useNavigate 훅을 사용하여 navigate 함수를 초기화
	// const location = useLocation();
	// const query = new URLSearchParams(location.search);
	// const score = parseInt(query.get('score'), 10) || 0;
	// const { score } = useParams();
	const { score: scoreParam } = useParams();
	const score = parseInt(scoreParam, 10);
	const [copied, setCopied] = useState(false);

	useEffect(() => {
		// Kakao SDK 불러오기 및 초기화
		const script = document.createElement('script');
		script.src = 'https://developers.kakao.com/sdk/js/kakao.js';
		script.async = true;
		document.body.appendChild(script);

		script.onload = () => {
			window.Kakao.init(process.env.REACT_APP_KAKAO_KEY); // 앱의 JavaScript 키 입력
		};

		return () => {
			document.body.removeChild(script);
		};
	}, []);

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const greenBubbleImage =
		windowWidth > 600
			? '/assets/green_bubble2_PC.png'
			: '/assets/green_bubble2_MO.png';

	const ResultData2 = [
		{
			no: 1,
			type: 1,
			title: '예비 돌멩이',
			picture: '/assets/result2_1.webp',
			description: '돌멩이가 되어 주실래요 임오 삼튠?\n오늘부터 귀여운 루이 후이에게 관심 가져주세요~',
			content1: '판다 눈썰미 ZERO ',
			content2: '루이와 후이를 실제로 보지 못한 예비 돌멩이',
			content3: '지금 당장 1탄부터 공부하고 오세요!',
			ogImage: '/assets/result2_1.webp',
			kakaoShareImage: '/assets/result2_1.webp',
		},
		{
			no: 2,
			type: 2,
			title: '돌멩이 입문?!',
			picture: '/assets/result2_2.webp',
			description:
				'루이와 후이에 관심이 생긴 임오, 삼튠!\n우리도 푸언니만큼 귀엽다고요~! 조금 더 귀여워해주세오!!',
			content1: '루이와 후이를 제대로 구분하지 못해요!',
			content2: '문제를 찍어서 맞춘 건 아니겠죠?',
			content3: '지금 당장 1탄부터 공부하고 오세요!',
			ogImage: '/assets/result2_2.webp',
			kakaoShareImage: '/assets/result2_2.webp',
		},
		{
			no: 3,
			type: 3,
			title: '루이 후이 초급 감별사',
			picture: '/assets/result2_3.webp',
			description:
				'루이와 후이를 구분하기 시작한 임오, 삼튠!\n좋아요 감 잡았어오~ 조금 더 연구해보세오~!!',
			content1: '루이와 후이의 귀여움에 빠진 임오, 삼툔!',
			content2: '판다 눈썰미가 제법이에요!',
			content3: '1탄 다시 복습하고 다시 도전해볼까요 ? ',
			ogImage: '/assets/result2_3.webp',
			kakaoShareImage: '/assets/result2_3.webp',
		},
		{
			no: 4,
			type: 4,
			title: '루이 후이 중급 감별사',
			picture: '/assets/result2_4.webp',
			description:
				'루이와 후이에 대해 관심이 많은 임오, 삼튠!\n귀여운 우리를 더 관찰해보세오~!!',
			content1: '완벽하지는 않지만 루이와 후이를 구분할 수 있어요~!!',
			content2: '조금 더 루이와 후이의 일상에 빠져보는건 어때요?',
			content3: '힘내서 테스트 만점에 다시 도전해보세요~!!',
			ogImage: '/assets/result2_4.webp',
			kakaoShareImage: '/assets/result2_4.webp',
		},
		{
			no: 5,
			type: 5,
			title: '루이 후이 고급감별사',
			picture: '/assets/result2_5.webp',
			description: '루이와 후이를 거의 완벽하게 구별할 수 있어오~!!\n이제 루후 마스터에 도전해보세오!',
			content1: '아깝게 만점실패ㅠㅠ',
			content2: '루이 후이 사진과 영상으로 힐링하는 임오, 삼툔!!',
			content3: '거의 다왔어요! 루이 후이 테스트 만점에 다시 도전하세요!',
			ogImage: '/assets/result2_5.webp',
			kakaoShareImage: '/assets/result2_5.webp',
		},
		{
			no: 6,
			type: 6,
			title: '루이 후이 감별 마스터',
			picture: '/assets/result2_6.webp',
			description:
				'축하합니다! 당신은 루후 감별 마스터! \n임오, 삼튠 최고에오~!!',
			content1: '루이, 후이를 완벽하게 구분할 줄 알아요!',
			content2: '판월 초밥돌기, 고독방 눈팅이 일상인 임모, 삼툔!',
			content3: '판다 눈썰미 상위 1% 마스터 금메달을 드립니댜!',
			ogImage: '/assets/result2_6.webp',
			kakaoShareImage: '/assets/result2_6.webp',
		},
	];

	if (isNaN(score) || score < 0 || score > 10) {
		return null; // 유효하지 않은 점수에 대해서는 아무것도 렌더링하지 않음
	}

	let result;
	if (score === 0) {
		result = ResultData2.find(data => data.type === 1);
	} else if (score >= 1 && score <= 2) {
		result = ResultData2.find(data => data.type === 2);
	} else if (score >= 3 && score <= 5) {
		result = ResultData2.find(data => data.type === 3);
	} else if (score >= 6 && score <= 7) {
		result = ResultData2.find(data => data.type === 4);
	} else if (score >= 8 && score <= 9) {
		result = ResultData2.find(data => data.type === 5);
	} else if (score === 10) {
		result = ResultData2.find(data => data.type === 6);
	} else {
		result = null; // 예외 처리: 잘못된 스코어 값이 들어오는 경우
	}

	const handleStartClick2 = () => {
		navigate('/v2');
		window.scrollTo(0, 0); // /quiz 경로로 이동
	};
	const handleStartClick = () => {
		navigate('/');
		window.scrollTo(0, 0); // /quiz 경로로 이동
	};
	const handleAnswerClick = () => {
		navigate('/answer2');
		window.scrollTo(0, 0); // /quiz 경로로 이동
	};

	if (!result) {
		return null; // 결과가 없을 경우 아무것도 렌더링하지 않음
	}

	const handleKakaoShare = () => {
		const resultUrl = `https://ruibao-huibao-test.web.app/result2/${score}`;

		window.Kakao.Share.sendDefault({
			objectType: 'feed',
			content: {
				title: '나의 판다력은?',
				description: '#루이바오 #후이바오 #판다테스트',
				imageUrl: `https://ruibao-huibao-test.web.app${result.kakaoShareImage}`,
				link: {
					mobileWebUrl: resultUrl,
					webUrl: resultUrl,
				},
			},
			buttons: [
				{
					title: '나의 판다력 보러가기',
					link: {
						mobileWebUrl: resultUrl,
						webUrl: resultUrl,
					},
				},
			],
		});
	};

	const copyLinkToClipboard = () => {
		const url = window.location.href;
		navigator.clipboard.writeText(url);
		setCopied(true);
		setTimeout(() => {
			setCopied(false);
		}, 2000); // 2초 후에 copied 상태를 다시 false로 설정하여 토스트 메시지가 사라지도록 함
	};

	const currentUrl = `https://ruibao-huibao-test.web.app/result2/${score}`;

	return (
		<div className="result-container2">
			<Helmet>
				<title>{`나의 판다 구별 점수는 ${score}점`}</title>
				<meta property="og:site_name" content="루이바오 후이바오" />
				<meta
					property="og:image"
					content={`https://ruibao-huibao-test.web.app${result.ogImage}`}
				/>
				<meta property="og:title" content="루이바오 후이바오 테스트" />
				<meta
					property="og:description"
					content="문제를 맞추고 판다력을 확인하세요!"
				/>
				<meta property="og:type" content="website" />
				<meta property="og:url" content={currentUrl} />
			</Helmet>
			<div className="result-contents">
				<div className="result-head">나의 판다 구별 점수는</div>
				<div className="result-score">{score}점</div>
				<div className="result-title-wrapper">
					<div className="result-title">{result.title}</div>
					<div className="result-title-underline2"></div>
				</div>
				<div className="result-description2">
					<div className="result-description-text-wrapper">
						<div className="result-description-text">{result.description}</div>
					</div>
					<img src={greenBubbleImage} alt="Green Bubble" />
				</div>
				<div className="result-img">
					<img
						src={`${result.picture}`}
						className="result-image"
						alt="result"
					/>
				</div>
				<div className="result-detail2">
					<div className="result-detail-title">
						당신의 판다력은?<span className="emoji">🐼</span>
					</div>
					<div className="result-detail-body">
						<ul className="result-detail-body-text">
							<li className="result-detail-content"> {result.content1}</li>
							<li className="result-detail-content"> {result.content2}</li>
							<li className="result-detail-content"> {result.content3}</li>
						</ul>
					</div>
				</div>
				<div className="result-share-title">
					<p className="result-share-text">퀴즈 결과를 친구들과 공유하고,</p>
					<p className="result-share-text">루이 후이의 귀여운 모습 자랑하기~!!</p>
					</div>
				<div className="result-share-wrap">
					<div className="result-share-kakao" onClick={handleKakaoShare}></div>
					<div
						className="result-share-link"
						onClick={copyLinkToClipboard}
					></div>
					{copied && (
						<div className="toast-message">링크가 복사되었습니다 🐼</div>
					)}
				</div>
				<button
					className="result-button2"
					id="StartAgainButton2"
					onClick={handleStartClick2}
				>
					테스트 다시하기
				</button>
				<button className="answer-button" onClick={handleAnswerClick}>
					루이, 후이 구별법 보러가기
				</button>
				<div className="goto-next" onClick={handleStartClick}>1탄으로 몸풀기 먼저하세요! 👉
				</div>
			</div>
		</div>
	);
};

export default ResultPage2;
